import React from 'react';
import { ShoppingBag, MessageCircle } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { Button } from './ui/button';

export const FloatingCartBar = ({ onCartClick }) => {
  const { getTotalItems, getTotal } = useCart();
  const totalItems = getTotalItems();
  const total = getTotal();

  if (totalItems === 0) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-border p-4 shadow-[0_-4px_20px_-1px_rgba(0,0,0,0.15)] z-50 md:hidden"
      data-testid="floating-cart-bar"
    >
      <div className="flex items-center justify-between gap-4">
        <button 
          onClick={onCartClick}
          className="flex items-center gap-3"
          data-testid="floating-cart-button"
        >
          <div className="relative">
            <ShoppingBag className="w-6 h-6 text-primary" />
            <span className="absolute -top-2 -right-2 bg-primary text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
              {totalItems}
            </span>
          </div>
          <div className="text-left">
            <p className="text-xs text-muted-foreground">{totalItems} {totalItems === 1 ? 'item' : 'itens'}</p>
            <p className="font-black text-primary text-lg">
              R$ {total.toFixed(2).replace('.', ',')}
            </p>
          </div>
        </button>

        <Button
          onClick={onCartClick}
          className="bg-[#25D366] hover:bg-[#128C7E] text-white font-bold px-6 py-3 rounded-full flex items-center gap-2"
          data-testid="floating-checkout-button"
        >
          <MessageCircle className="w-5 h-5" />
          Pedir
        </Button>
      </div>
    </div>
  );
};
